import { TranslateLanguage } from './KeywordTranslator';
import { parseQTVideoDate } from './QT';

const SOURCE_CONFIG = {
  GRACE365: {
    label: '恩典365',
    playlistId: 'UUNBgquLyP2zOAJURDJAUYTA',
    sourceURL: 'https://www.youtube.com/user/hvfhoc123',
    matchesTitle: title => title.includes('恩典365'),
    getDate: (title, publishedAt) => parseQTVideoDate(title) || parsePublishedDate(publishedAt),
  },
  PRAYER: {
    label: '禱告時光',
    playlistId: 'UUleOZrc4iverW4h7Ohdv3Cg',
    sourceURL: 'https://www.youtube.com/channel/UCleOZrc4iverW4h7Ohdv3Cg/videos',
    matchesTitle: title => title.includes('禱告時光'),
    getDate: (title, publishedAt) => parseQTVideoDate(title) || parsePublishedDate(publishedAt),
  },
};

const toLocalDateKey = date => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const parsePublishedDate = publishedAt => (
  publishedAt ? toLocalDateKey(new Date(publishedAt)) : ''
);

const buildSourceMessage = (config, message) => (
  `<p>${message}</p><p><a target="_blank" rel="noreferrer" href="${config.sourceURL}">`
  + `${TranslateLanguage(localStorage.userLanguage, '前往原始來源')}</a></p>`
);

export const getDailyArchiveLabel = source => (
  SOURCE_CONFIG[source]?.label || ''
);

export const loadDailyArchive = async (source, YTKey) => {
  const config = SOURCE_CONFIG[source];
  if (!config) return { items: [], message: '', sourceURL: '', label: '' };

  const requestURL = 'https://www.googleapis.com/youtube/v3/playlistItems'
    + `?part=snippet&maxResults=50&playlistId=${config.playlistId}&key=${YTKey}`;
  const response = await fetch(requestURL);
  if (!response.ok) {
    throw new Error(`YouTube request failed with status ${response.status}`);
  }

  const data = await response.json();
  const videosByDate = new Map();

  for (const item of data?.items ?? []) {
    const snippet = item?.snippet;
    const title = snippet?.title || '';
    const videoId = snippet?.resourceId?.videoId;
    if (!videoId || !config.matchesTitle(title)) continue;

    const date = config.getDate(title, snippet.publishedAt || '');
    if (!date || videosByDate.has(date)) continue;

    videosByDate.set(date, {
      date,
      text: title,
      videoId,
      url: `https://www.youtube.com/watch?v=${videoId}`,
      publishedAt: snippet.publishedAt || '',
      thumbnail: snippet.thumbnails?.medium?.url || snippet.thumbnails?.default?.url || '',
    });
  }

  const items = Array.from(videosByDate.values())
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 20);
  const message = TranslateLanguage(
    localStorage.userLanguage,
    '抱歉，沒有找到可播放的內容，請稍後再試。'
  );

  return {
    items,
    label: config.label,
    sourceURL: config.sourceURL,
    message: buildSourceMessage(config, message),
  };
};
